import { Alert, Icons } from '@commenda/kakashi';

interface ValidationErrorAlertProps {
  errors: string[];
}

export function ValidationErrorAlert({ errors }: ValidationErrorAlertProps) {
  if (!errors || errors.length === 0) return null;

  return (
    <Alert
      variant="destructive"
      icon={<Icons.AlertCircle className="size-5 text-text-error" />}
      title={errors.length === 1 ? 'Validation error' : 'Validation errors'}
      description={errors.length > 0 ? errors[0] : 'Error message not found'}
    />
  );
}
